export default {
      id: "pdf-usage",
      viewBox: "0 0 17 22.7",
      url: __webpack_public_path__ + "svg/sprite.svg#pdf",
      toString: function () {
        return this.url;
      }
    }